import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Typography } from '@material-ui/core';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import DropzoneMulti from './DropzoneMulti';

const MultipleFileUpload = ({ name, props: { label, rules, s3Directory } }) => {
    const classes = useReactHookFormStyles();

    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <>
            <Typography className="my-8">{label}</Typography>
            <FormControl className={classes.formController}>
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field: { onChange, value } }) => {
                        return (
                            <DropzoneMulti
                                handleDrop={async (files, e) => {
                                    if (!files || !files.length) {
                                        onChange(null);
                                        return;
                                    }
                                    onChange(files);
                                }}
                                values={value}
                                s3Directory={s3Directory}
                            />
                        );
                    }}
                />
                {errors[name] && <FormHelperText>{errors[name]?.message}</FormHelperText>}
            </FormControl>
        </>
    );
};

export default React.memo(MultipleFileUpload);
